export default "__VITE_ASSET__lyJ$ccVK__"